import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UQUAL_AD_BANNER_DISMISS_KEY } from "utilities/Constant";

interface UqualAdBannerState {
  bannerDismissed: boolean;
}

const initialState: UqualAdBannerState = {
  bannerDismissed: sessionStorage.getItem(UQUAL_AD_BANNER_DISMISS_KEY) === "true",
};

const uqualAdBannerSlice = createSlice({
  name: "uqualAdBanner",
  initialState,
  reducers: {
    setUqualAdBannerDismissed(state, action: PayloadAction<boolean>) {
      state.bannerDismissed = action.payload;
    },
  },
});

export const { setUqualAdBannerDismissed } = uqualAdBannerSlice.actions;

export const selectIsUqualAdBannerDismissed = (state: { uqualAdBanner: UqualAdBannerState }) => state.uqualAdBanner.bannerDismissed;

export default uqualAdBannerSlice.reducer;
